import axios from 'axios'
axios.defaults.timeout = 1000000
axios.defaults.headers['Content-Type'] = 'application/json'
axios.defaults.headers['mall-api-token'] = localStorage.getItem('Authorization');
export default {
  fetchGet (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchQuickSearch (url) {
    return new Promise((resolve, reject) => {
      axios.get(url).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchPost (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.post(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //商品首页列表
  getGoodsList(url,params = {}) {
    return axios({
      url: url,
      method:'get',
      params
    })
  },
  //商品详情
  getGoodDetails(params = {}) {
    return axios({
      url: "/mallApi/mall/index/queryById?id="+params,
      method:'get'
    })
  },
  addCart(params = {}){
    return axios({
      url: "/mallApi/mall/shopCart/add",
      method: 'post',
      params
    })
  },
  setLocalStorge(){
    localStorage.setItem('Authorization', "");
    localStorage.setItem('userName', "");
    localStorage.setItem('logoUrl', "");
    localStorage.setItem('phone', "");
  },
  changeUnitPrice(x) {  
    　　var f_x = parseFloat(x);  
    　　if (isNaN(f_x))  
    　　{  
    　　　　return 0;  
    　　}  
    　　var f_x = Math.round(x*100)/100;  
    　　var s_x = f_x.toString();  
    　　var pos_decimal = s_x.indexOf('.');  
    　　if (pos_decimal < 0)  
    　　{  
    　　　　pos_decimal = s_x.length;  
    　　s_x += '.';  
    　　}  
    　　while (s_x.length <= pos_decimal + 2)  
    　　{  
    　　　　s_x += '0';  
    　　}  
    　　return s_x;  
    },
    successMessage(that){
      that.$message({
        showClose: true,
        message: '操作成功！',
        type: 'success'
      });
    },
    errorMessage(that){
      that.$message({
        showClose: true,
        message: '操作失败！',
        type: 'error'
      });
    },
    warningMessage(){
      this.$message({
        showClose: true,
        message: '请至少勾选一条数据！',
        type: 'warning'
      });
    },
    infoMessage(msg){
      this.$message({
        showClose: true,
        duration:0,
        message: msg
      });
    }
}



// WEBPACK FOOTER //
// ./src/api/public.js